import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import AsyncSelect from 'react-select/async'
import makeAnimated from 'react-select/animated'
import {convertToWK} from 'wkt-parser-helper'

import {IProperties, propertiesInitValues as initialValues} from '../../models/PropertiesModel'
import {KTSVG} from '../../../../..//../_metronic//helpers'
import {PointAdd} from '../../../../../../_metronic/partials/widgets/map/pointAdd'
import {Input3} from '../../../../../../components/Forms/Input'
import InputMask from 'react-input-mask'
import {MultiSelect} from 'primereact/multiselect'
import {colourStyles} from '../../components/styles/styles'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const API_URL = process.env.REACT_APP_API_URL || 'api'

const propertiesSchema = Yup.object().shape({})

const AddProperties: React.FC = () => {
  useEffect(() => {
    loadOptionsEnterprises()
  }, [])

  useEffect(() => {
    loadOptionsFields()
  }, [])

  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [selectedFields, setSelectedFields] = useState(null)
  const [field, setFields] = useState([])
  const [selectedEnterprises, setSelectedEnterprises] = useState(null)
  const [enterprises, setEnterprises] = useState([])

  const formik = useFormik<IProperties>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      if (values.latitude !== 0 && values.longitude !== 0) {
        const geojsonPoint = {
          type: 'Point',
          coordinates: [values.latitude, values.longitude],
        }
        values.geom_point = convertToWK(geojsonPoint as any)
      }
      try {
        await axios.post(`${API_URL}/sgt/v1/properties`, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PROPERTIES.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/properties')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PROPERTIES.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    formik.resetForm()
    setSelectedFields(null)
    setSelectedEnterprises(null)
  }

  const animatedComponents = makeAnimated()

  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()

      let projects: any = []
      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const project: any = {
              value: element.id,
              label: `${element.code} - ${element.description} `,
            }
            projects.push(project)
          }
        }
      }
      callback(projects)
    }, 1000)
  }

  const handleInputChangeProject = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    formik.setFieldValue('project_id', inputValue)
    return {inputValue}
  }

  function searchCEP(ev: any) {
    const {value} = ev.target

    const cep = value?.replace(/[^0-9]/g, '')

    if (cep?.length !== 8) {
      return
    }
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((data) => {
        formik.setFieldValue('zip_code', data.cep)
        formik.setFieldValue('state', data.uf)
        formik.setFieldValue('city', data.localidade)
        formik.setFieldValue('street_name', data.logradouro)
        formik.setFieldValue('district', data.bairro)
      })
  }

  const loadOptionsFields = () => {
    setTimeout(() => {
      getFields()
      let fields: any = []
      async function getFields() {
        const {data} = await axios.get(API_URL + '/v1/fields/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const field: any = {
              code: element.id,
              name: `${element.name} - ${element.description} `,
            }
            fields.push(field)
          }
        }
      }
      setFields(fields)
      return fields
    }, 1000)
  }

  const loadOptionsEnterprises = () => {
    setTimeout(() => {
      getEnterprises()
      let enterprises: any = []
      async function getEnterprises() {
        const {data} = await axios.get(API_URL + '/v1/enterprises/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const enterprise: any = {
              code: element.id,
              name: element.text,
            }
            enterprises.push(enterprise)
          }
        }
      }
      setEnterprises(enterprises)
      return enterprises
    }, 1000)
  }

  return (
    <div className='card card-custom mt-n6'>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'LICENSE_TYPES.NEW_LICENSE'})}
      </PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='col-lg-7'>
                  {/* INICIO NOME PROPRIEDADE */}
                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      <label className='col-form-label required fw-bold fs-6'>
                        {intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                        {...formik.getFieldProps('name')}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className='fv-plugins-message-container text-danger'>
                          <div className='fv-help-block'>{formik.errors.name}</div>
                        </div>
                      )}
                    </div>

                    <div className='col-lg-6'>
                      <label className='col-form-label  fw-bold fs-6'>
                        {intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                        {...formik.getFieldProps('identifier')}
                      />
                      {formik.touched.identifier && formik.errors.identifier && (
                        <div className='fv-plugins-message-container text-danger'>
                          <div className='fv-help-block'>{formik.errors.identifier}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* FIM NOME PROPRIEDADE */}

                  {/* INICIO Lucro ----------------------*/}
                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      <label className='col-form-label fw-bold fs-6'>
                        <span className='required'>Deveria Ter Participação?</span>
                      </label>

                      <select
                        className='form-select form-select-solid ps-6'
                        data-kt-select2='true'
                        {...formik.getFieldProps('should_have_participation')}
                      >
                        <option></option>
                        <option value='yes'>{intl.formatMessage({id: 'COMMON.YES'})}</option>
                        <option value='no'>{intl.formatMessage({id: 'COMMON.NO'})}</option>
                      </select>
                      {formik.touched.should_have_participation &&
                        formik.errors.should_have_participation && (
                          <div className='fv-plugins-message-container text-danger'>
                            <div className='fv-help-block'>
                              {formik.errors.should_have_participation}
                            </div>
                          </div>
                        )}
                    </div>

                    <div className='col-lg-6'>
                      <label className='col-form-label fw-bold fs-6'>
                        <span className='required'>
                          {intl.formatMessage({id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE'})}
                        </span>
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({
                          id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE',
                        })}
                        {...formik.getFieldProps('indirect_profit_rate')}
                      />
                      {formik.touched.indirect_profit_rate && formik.errors.indirect_profit_rate && (
                        <div className='fv-plugins-message-container text-danger'>
                          <div className='fv-help-block'>{formik.errors.indirect_profit_rate}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* FIM Lucro ------------------------------*/}

                  {/* INICIO UNIDADE/SETOR ----------------------*/}
                  <div className='row mb-3'>
                    <label className='col-form-label fw-bold fs-6'>
                      <span className='required'>
                        {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
                      </span>
                    </label>

                    <MultiSelect
                      className='form-control form-control-lg form-control-solid p-1 pl-1 border border-white'
                      value={selectedFields}
                      options={field}
                      style={{
                        fontFamily: 'Poppins',
                        fontSize: '1.15rem',
                        fontWeight: 'medium',
                      }}
                      onChange={(e) => {
                        formik.setFieldValue(
                          'field_id',
                          e.value.map((v: any) => {
                            return v.code
                          })
                        )

                        setSelectedFields(e.value)
                      }}
                      placeholder={intl.formatMessage({
                        id: 'ENTERPRISES.INPUT_FIELDS_SELECT',
                      })}
                      optionLabel='name'
                      filter
                      display='chip'
                    />
                  </div>
                  {/* FIM UNIDADE / SETOR ------------------------------*/}

                  {/* INICIO EMPREEDIMENTO ----------------------*/}
                  <div className='row mb-3'>
                    <label className='col-form-label fw-bold fs-6'>
                      <span className='required'>
                        {intl.formatMessage({id: 'ENTERPRISES.INPUT_NAME'})}
                      </span>
                    </label>

                    <MultiSelect
                      className='form-control form-control-lg form-control-solid p-1 pl-1 border border-white'
                      value={selectedEnterprises}
                      options={enterprises}
                      style={{
                        fontFamily: 'Poppins',
                        fontSize: '1.15rem',
                        fontWeight: 'medium',
                      }}
                      onChange={(e) => {
                        formik.setFieldValue(
                          'enterprise_id',
                          e.value.map((v: any) => {
                            return v.code
                          })
                        )

                        setSelectedEnterprises(e.value)
                      }}
                      placeholder={intl.formatMessage({
                        id: 'ENTERPRISES.INPUT_ENTERPRISE_SELECT',
                      })}
                      optionLabel='name'
                      filter
                      display='chip'
                    />
                  </div>
                  {/* FIM EMPREEDIMENTO ------------------------------*/}
                  {/* INICIO PROJETO ----------------------*/}
                  <div className='row mb-3'>
                    <label className=' col-form-label fw-bold fs-6'>
                      <span className='required'>{intl.formatMessage({id: 'MENU.PROJECTS'})}</span>
                    </label>

                    <AsyncSelect
                      className='form-control form-control-lg form-control-solid p-1 ps-3'
                      styles={colourStyles}
                      components={animatedComponents}
                      cacheOptions
                      loadOptions={loadOptionsProjects}
                      filterOption={(option, inputValue) =>
                        option.label
                          ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                          : false
                      }
                      defaultOptions
                      onChange={handleInputChangeProject}
                      placeholder={intl.formatMessage({
                        id: 'ENTERPRISES.INPUT_PROJECT_SELECT',
                      })}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                        },
                      })}
                    />
                  </div>
                  {/* FIM PROJETO ------------------------------*/}

                  {/* INICIO CEP */}
                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                        <span>{intl.formatMessage({id: 'COMMON.INPUT_ZIPCODE'})}</span>
                      </label>

                      <InputMask
                        mask='99999-999'
                        type='text'
                        className='form-control form-control-lg form-control-solid p-1 ps-5'
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_ZIPCODE'})}
                        onBlur={(e) => {
                          searchCEP(e)
                        }}
                      />
                    </div>
                    {/* INICIO ESTADO ----------------------*/}
                    <div className='col-lg-6'>
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.INPUT_STATE'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_STATE'})}
                        {...formik.getFieldProps('state')}
                      />
                    </div>
                    {/* FIM ESTADO ------------------------------*/}
                  </div>

                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      {/* INICIO Logradouro */}
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.INPUT_ADDRESS'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_ADDRESS'})}
                        {...formik.getFieldProps('street_name')}
                      />
                      {/* FIM Logradouro */}
                    </div>
                    {/* INICIO CIDADES ----------------------*/}
                    <div className='col-lg-6'>
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.INPUT_CITY'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_CITY'})}
                        {...formik.getFieldProps('city')}
                      />
                      {/* FIM CIDADES ------------------------------*/}
                    </div>
                  </div>

                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      {/* INICIO Bairro */}

                      <Input3
                        title={intl.formatMessage({id: 'COMMON.INPUT_DISTRICT'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_DISTRICT'})}
                        {...formik.getFieldProps('district')}
                      />
                      {/* FIM Bairro */}
                    </div>
                    {/* INICIO CIDADES ----------------------*/}
                    <div className='col-lg-6'>
                      {/* INICIO Número */}
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.INPUT_NUMBER'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_NUMBER'})}
                        {...formik.getFieldProps('number')}
                      />
                      {/* FIM Número */}
                    </div>
                  </div>

                  <div className='row mb-3'>
                    <div className='col-lg-12'>
                      {/* INICIO Complemento */}
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.INPUT_COMPLEMENT'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_COMPLEMENT'})}
                        {...formik.getFieldProps('complement')}
                      />
                      {/* FIM Complemento */}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className='d-flex justify-content-end py-6'>
                    <button type='submit' className='btn btn-primary' disabled={loading}>
                      {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    <button type='reset' onClick={resetInputs} className='btn btn-secondary mx-2'>
                      {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
                    </button>
                  </div>
                </div>
                {/* ----------------------------------------------------------------------------------- */}

                <div className='col-lg-5'>
                  <PointAdd
                    latitude={latitude}
                    longitude={longitude}
                    name={'Novo'}
                    description={'Localização do novo empreendimento'}
                  />
                  {/* <Map
                    style={{width: '90vw', height: '90vh'}}
                    mapProperties={{basemap: 'hybrid'}}
                    viewProperties={{
                      center: [0.28995, -30.31557],
                      zoom: 4,
                    }}
                  >
                    <PointAdd latitude={latitude} longitude={longitude} />
                  </Map> */}

                  <div className='d-flex justify-content-start py-6'>
                    <button
                      type='button'
                      className='btn btn-primary'
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_1'
                    >
                      Adicionar vertices
                    </button>
                    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
                      <div className='modal-dialog'>
                        <div className='modal-content'>
                          <div className='modal-header'>
                            <h4 className='modal-title'>Inserir Geometria Através de Vertices</h4>
                            <div
                              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                              data-bs-dismiss='modal'
                              aria-label='Close'
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr061.svg'
                                className='svg-icon svg-icon-2x'
                              />
                            </div>
                          </div>

                          <div className='modal-body'>
                            {/* INICIO HTML Tipo de Geometria */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold fs-6'>
                                {/* <span>{intl.formatMessage({id: 'COMMON.INPUT_STATE'})}</span> */}
                                Tipo de Geometria
                              </label>

                              <div className='col-lg-7 fv-row'>
                                <select
                                  className='form-select form-select-solid form-select-lg fw-bold'
                                  {...formik.getFieldProps('type_geometry')}
                                >
                                  <option value='point'>Ponto</option>
                                  <option value='line'>Linha</option>
                                  <option value='polygon'>Polígono</option>
                                </select>
                              </div>
                            </div>

                            {/* FIM Tipo de Geometria */}

                            {/* INICIO HTML Coordenadas */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold fs-6'>
                                {/* <span>{intl.formatMessage({id: 'COMMON.INPUT_STATE'})}</span> */}
                                Tipo de Coordenada
                              </label>

                              <div className='col-lg-7 fv-row'>
                                <select
                                  className='form-select form-select-solid form-select-lg fw-bold'
                                  {...formik.getFieldProps('type_coordinate')}
                                >
                                  <option value='projetada'>Projetada</option>
                                  <option value='lat_long'>Lat / Long</option>
                                </select>
                              </div>
                            </div>

                            {/* FIM Tipo de Geometria */}

                            {/* INICIO Latitude */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold fs-6'>
                                Latitude/N
                              </label>

                              <div className='col-lg-7'>
                                <div className='row'>
                                  <div className='col-lg-12 fv-row'>
                                    <input
                                      type='TEXT'
                                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                      placeholder={
                                        'Digite a Latitude'
                                        // intl.formatMessage({id: 'ENTERPRISES.INPUT_ACTIVE_PLACEHOLDER' })
                                      }
                                      {...formik.getFieldProps('latitude')}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* FIM Latitude */}

                            {/* INICIO Latitude */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold fs-6'>
                                Longitude/E
                              </label>

                              <div className='col-lg-7'>
                                <div className='row'>
                                  <div className='col-lg-12 fv-row'>
                                    <input
                                      type='TEXT'
                                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                      placeholder={
                                        'Digite a Longitude'
                                        // intl.formatMessage({id: 'ENTERPRISES.INPUT_ACTIVE_PLACEHOLDER' })
                                      }
                                      {...formik.getFieldProps('longitude')}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* FIM Latitude */}
                            {/* INICIO COMPRIMENTO */}
                            <div className='row mb-3'>
                              <label className='col-lg-12 col-form-label fw-bold fs-6'>
                                {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                              </label>

                              <div className='col-lg-12'>
                                <div className='row'>
                                  <div className='col-lg-12 fv-row'>
                                    <textarea
                                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                      aria-multiline='true'
                                      disabled
                                      {...formik.getFieldProps('description')}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* FIM COMPRIMENTO */}
                          </div>

                          <div className='modal-footer' data-bs-dismiss='modal'>
                            <button
                              type='button'
                              className='btn btn-primary'
                              onClick={() => {
                                setLatitude(formik.getFieldProps('latitude').value)
                                setLongitude(formik.getFieldProps('longitude').value)
                              }}
                            >
                              Inserir Geometria
                            </button>

                            {/* <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                              Sair
                            </button> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <button className='btn btn-primary  mx-2' type='button'>
                      Adicionar Sharefile
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {AddProperties}
